export default __webpack_public_path__ + "static/media/la_ferte-vidame02.0287445e.jpg";